// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-wrapper-pdf,.file-wrapper-pdf .file-wrapper-pdf-content{height:100%}.file-wrapper-pdf .file-wrapper-pdf-nodata{margin-top:64px}.file-wrapper-pdf .file-wrapper-pdf-nodata .pt_nodata-title{color:#8993a4;font-size:14px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
